/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_BackInputs */

const en_us2_clubs_back = /** @type {(inputs: Clubs_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

const pt_br2_clubs_back = /** @type {(inputs: Clubs_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar`)
};

const es_419_clubs_back = /** @type {(inputs: Clubs_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver`)
};

const pt_pt2_clubs_back = /** @type {(inputs: Clubs_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar`)
};

const fr_fr2_clubs_back = /** @type {(inputs: Clubs_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour`)
};

const de_de2_clubs_back = /** @type {(inputs: Clubs_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

const it_it2_clubs_back = /** @type {(inputs: Clubs_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indietro`)
};

/**
* | output |
* | --- |
* | "Back" |
*
* @param {Clubs_BackInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_back = /** @type {((inputs?: Clubs_BackInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_BackInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_back(inputs)
	if (locale === "es-419") return es_419_clubs_back(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_back(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_back(inputs)
	if (locale === "de-DE") return de_de2_clubs_back(inputs)
	if (locale === "it-IT") return it_it2_clubs_back(inputs)
	return en_us2_clubs_back(inputs)
});
export { clubs_back as "clubs.back" }